import React from 'react';
import type { IconProps } from '../types';

export const IconCreditCard: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect x="2.5" y="4.5" width="15" height="11" rx="2" stroke={color} strokeWidth="1.5" />
    <path d="M2.5 8H17.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M6 12.5H9" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

